import { specialTicketTypes } from "utils/consts";
export const transformEmailAddr = (email) => {
    return email.toLowerCase().replace(/\+.*@/g, "@");
};
export const showConcatTicketName = (t, tickets) => {
    var _a;
    return tickets.length > 1
        ? tickets.map((ticket) => t(ticket.id)).join(", ")
        : t(`${(_a = tickets[0]) === null || _a === void 0 ? void 0 : _a.id}`);
};
// concatenate special tickets, return [[normal1], [normal2] [special1, special2] struct
export const concatSpecialTicket = (tickets) => {
    let concated = tickets.reduce((p, c) => specialTicketTypes.includes(c.id)
        ? [[...p[0], c], ...p.slice(1)]
        : [...p, [c]], [[]]);
    concated = concated.filter((c) => c.length > 0);
    //console.log("concated:::", concated);
    let sortedConcate = concated.sort((a, b) => {
        return a[0].displayOrder - b[0].displayOrder;
    });
    return sortedConcate;
};
